<script>
import { headerMagasinProps, useHeaderMagasin } from "./mixin";
import Icon from "@/components/atoms/icon";
import Button from "@/components/atoms/button";
import WidgetPlanning from "@/containers/planning/widget-planning";
import Popin from "@/components/molecules/popin";

export default {
  name: "MonMagasinMobile",
  components: { Button, Icon, WidgetPlanning, Popin },
  props: {
    ...headerMagasinProps()
  },
  setup(props) {
    const { isOpened, showIfOpened } = useHeaderMagasin(props);
    return { isOpened, showIfOpened };
  }
};
</script>

<template>
  <div>
    <Popin
      ref="planning"
      aria-label="Mon magasin"
      page-back
    >
      <WidgetPlanning />
    </Popin>
    <div>
      <h2 class="c-header-menu-popin__title">
        <Icon
          name="shipping-drv"
          size="md"
          variant="primary"
          class="u-mr-sm"
        />
        Prochain créneau Drive
      </h2>
      <div class="c-header-menu-popin__creneau-drive">
        <p
          v-if="shopfirstSlotAvailable && shopfirstSlotAvailable!=='indisponible'"
          class="u-font-14"
        >
          {{ shopfirstSlotAvailable }}
        </p>
        <p
          v-else-if="shopfirstSlotAvailable && shopfirstSlotAvailable=='indisponible'"
          class="u-font-14"
        >
          Aucun créneau n'est disponible pour le moment
        </p>
        <Button
          class="u-mt-xxs"
          @click="$refs.planning.show()"
        >
          <span class="u-color-primary u-text-underline u-font-14">Voir le planning</span>
        </Button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/header-menu-popin.scss";
</style>
